import { render, staticRenderFns } from "./CbsUiArtifactFrame.vue?vue&type=template&id=3e031466"
import script from "./CbsUiArtifactFrame.vue?vue&type=script&lang=js"
export * from "./CbsUiArtifactFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports